import React from 'react';
import { getPriorityLabel } from '../../lib/priority';
import { printDate, printNumber, printStatus } from '../../lib/workOrderPrint';

export const PrintValue = ({ label, value, testId }) => value !== null && value !== undefined && value !== ''
  ? <div><dt>{label}</dt><dd data-testid={testId}>{value}</dd></div> : null;

export const PrintWorkOrderMeta = ({ data }) => {
  const wo = data.work_order;
  const machine = data.equipment;
  return <header className="wo-paper-header" data-testid="wo-print-header">
    <div className="wo-paper-identity">
      <strong data-testid="wo-print-number">Work order {wo.wo_number ? `#${wo.wo_number}` : wo.id}</strong>
      <span data-testid="wo-print-status">{printStatus(wo.status)}</span>
    </div>
    <h1 data-testid="wo-print-title">{wo.title}</h1>
    <dl className="wo-paper-meta" data-testid="wo-print-equipment-info">
      <PrintValue label="Equipment" value={machine?.component || 'Equipment record unavailable'} testId="wo-print-equipment" />
      <PrintValue label="Plant" value={data.plant_name || 'Location unavailable'} testId="wo-print-plant" />
      <PrintValue label="Equipment serial" value={machine?.serial_number} testId="wo-print-equipment-serial" />
      <PrintValue label="Equipment location" value={machine?.location} testId="wo-print-equipment-location" />
      {!machine && <PrintValue label="Equipment reference" value={wo.machinery_id} testId="wo-print-missing-equipment-id" />}
      <PrintValue label="Manufacturer / model" value={[machine?.manufacturer, machine?.model].filter(Boolean).join(' / ')} testId="wo-print-equipment-model" />
      <PrintValue label="Assigned to" value={wo.assigned_to} testId="wo-print-assigned-to" />
      <PrintValue label="Priority" value={wo.priority ? getPriorityLabel(wo.priority) : null} testId="wo-print-priority" />
      <PrintValue label="Calendar due" value={wo.due_date ? printDate(wo.due_date) : null} testId="wo-print-due" />
      <PrintValue label="Meter due at" value={wo.hours_due_at != null ? `${printNumber(wo.hours_due_at)} h` : null} testId="wo-print-meter-due" />
      <PrintValue label="Recurring interval" value={[wo.frequency_days ? `${wo.frequency_days} days` : '', wo.frequency_hours ? `${printNumber(wo.frequency_hours)} operating hours` : ''].filter(Boolean).join(' / ')} testId="wo-print-recurrence" />
    </dl>
    {data.installation_points.length > 0 && <div className="wo-paper-points" data-testid="wo-print-installation-points">
      <strong>Installation points</strong>
      <ul>{data.installation_points.map((point) => <li key={point.id} data-testid={`wo-print-point-${point.id}`}>
        {point.label || `Installation point record unavailable (${point.id})`}
      </li>)}</ul>
    </div>}
    {wo.source_work_order_id && <p className="wo-paper-origin" data-testid="wo-print-origin">
      Follow-up to service {wo.source_work_order_number ? `#${wo.source_work_order_number}` : wo.source_work_order_id}{wo.source_work_order_title ? ` · ${wo.source_work_order_title}` : ''}
    </p>}
  </header>;
};